import * as types from "../actions/types";

const initialState = null
// const initialState = 'https://certification.edumil.ru/files/cert_request_scan/1670/Zayavlenie_75d690.pdf'


export default function preview (state = initialState, action) {
  switch (action.type) {
    case types.SET_PREVIEW:
      return action.payload;
    default:
      return state;
  }
}